// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextInput_wrapper__lRKPR","input":"TextInput_input__uKIwG","textarea":"TextInput_textarea__QvPUj","label":"TextInput_label__s4S7E"};